import { render, staticRenderFns } from "./FileText.vue?vue&type=template&id=2280ef2e&scoped=true"
import script from "./FileText.vue?vue&type=script&lang=js"
export * from "./FileText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280ef2e",
  null
  
)

export default component.exports